import Switch from './src/switch.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToSwitch: SFCWithInstall<typeof Switch> = withInstall(Switch);

export * from './src/instance';